<template lang="pug">
div
  div.labelStatus(row, wrap)
    v-flex.xs12.pa-0.ma-0
      v-card(flat)
        v-flex(v-if="!isAberto", style="min-height:30px; flex-direction: column;").orange.md12.d-flex.align-center.justify-center.text-xs-center
          .subheading.font-weight-bold.white--text LOJA FECHADA
          small.font-weight-bold.white--text(v-if="hasRecessoAutomatico && !hasRecessoAdmin && !contratoSuspenso") A loja foi fechada pelo sistema. Você pode reabri-la quando quiser.
        v-flex(v-if="isAberto", style="height:30px").primary.md12.d-flex.align-center.justify-center.text-xs-center
          .subheading.font-weight-bold.white--text LOJA ABERTA
        v-flex(style="min-height:30px", v-if="(hasRecessoAdmin && !avisoFaturas) || contratoSuspenso" :class="{'orange': hasRecessoAdmin, 'red darken-1': contratoSuspenso}").md12.d-flex.align-center.justify-center.text-xs-center
          div
            span(v-if="hasRecessoAdmin && !contratoSuspenso && !avisoFaturas").subheading.font-weight-semibold.white--text Existe um recesso cadastrado pelo sistema.
            span(v-if="contratoSuspenso").subheading.font-weight-semibold.white--text Sua loja está suspensa.
            span(v-if="hasRecessoAdmin || contratoSuspenso" @click="contact", style="cursor:pointer").ml-1.subheading.font-weight-bold.gray--text Contatar Suporte

  div.labelFinanceiro(row, wrap, v-if="avisoFaturas && !contratoSuspenso && $root.podeAcessarPerfil(['administrador'])")
    v-flex.xs12.pa-0.ma-0
      v-card(flat)
        v-list(v-if="$root.boletosVencidos > 0", dense).red.darken-1
          v-list-tile(to="/delivery/financeiro")
            v-list-tile-content
              v-list-tile-title.body-2.font-weight-bold.text-xs-center.white--text Atenção! Você possui {{ $root.boletosVencidos }} {{ $root.boletosVencidos == 1 ? 'boleto' : 'boletos' }} em aberto.
              v-list-tile-sub-title.caption.text-xs-center.white--text Caso tenha realizado o pagamento desconsidere esta mensagem.
        v-list(dense, v-if="$root.boletosVencidos == 0 && $root.boletosVencendo > 0").orange.darken-1
          v-list-tile
            v-list-tile-content
              v-list-tile-title.body-2.font-weight-bold.text-xs-center.white--text Você possui {{ $root.boletosVencendo }} {{ $root.boletosVencendo == 1 ? 'boleto disponível' : 'boletos disponíveis' }} para pagamento.
              v-list-tile-sub-title.caption.text-xs-center.white--text Realize o pagamento até a data de vencimento para evitar a suspensão do serviço.
            v-list-tile-action
              v-btn(icon, @click="closeAlertBoletos")
                v-icon(color="white") close
</template>

<script>
import _ from "lodash";
import { registrarContatoSuporte } from '@/util/suporte';

const ADMIN_RECESSO_AUTOMATICO = 39;

export default {
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
    isAberto(){
      const delivery = this.estabelecimentoSelecionado.delivery ? this.estabelecimentoSelecionado.delivery[0] : null
      return delivery && delivery.aberto == 1 ? true : false;
    },
    contratoSuspenso () {
      return this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.status_delivery == 4 ? true : false;
    },
    hasRecessoAdmin(){
      if (!this.estabelecimentoSelecionado) return null;

      const recessosVigentes = this.estabelecimentoSelecionado.recessosVigentes;

      const recessosVigentesAdmin = _.filter(recessosVigentes, (o)=>{
        return o.admin_id && o.admin_id != ADMIN_RECESSO_AUTOMATICO ? true : false
      })

      return recessosVigentesAdmin.length ? true : false;
    },
    hasRecessoAutomatico(){
      if (!this.estabelecimentoSelecionado) return null;

      const recessosVigentes = this.estabelecimentoSelecionado.recessosVigentes;

      const recessosVigentesAutomatico = _.filter(recessosVigentes, (o)=>{
        return o.admin_id == ADMIN_RECESSO_AUTOMATICO ? true : false
      })

      return recessosVigentesAutomatico.length ? true : false;
    },
    avisoFaturas () {
      return ((this.$root.estabelecimentoSelecionado && this.$root.estabelecimentoSelecionado.id) || this.$root.estabelecimentos.length == 1) && this.$root.boletosDisponiveis > 0 && this.$root.alertBoletos;
    },
  },
  methods: {
    contact(){
      registrarContatoSuporte(this.contratoSuspenso ? 'status_loja_suspensa' : 'status_loja_recesso', this.estabelecimentoSelecionado);
      const url = `https://api.whatsapp.com/send?phone=5532988929726&text=Ol%C3%A1%20gostaria%20de%20saber%20sobre%20o%20recesso%20do%20estabelecimento%20${this.estabelecimentoSelecionado.nome + ' | ' + this.estabelecimentoSelecionado.id}`;
      window.open(url, '_blank');
    },
    closeAlertBoletos () {
      const vm = this;
      vm.$root.alertBoletos = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.labelStatus{
  height: auto;
}
.labelFinanceiro{
  height: auto;
}
</style>
